import api  from '../api'
import serializeError from 'serialize-error';

export default {
  info: msg => {
    logStub(msg);
  },

  warning: msg => {
    //eslint-disable-next-line
        console.warn(msg)
    submitAnomaly({
      errorType: 'warning',
      errorDescription: serializeError(msg),
      browserDetails: getBrowserDetails()
    })
  },

  error: msg => {
    //eslint-disable-next-line
        console.error(msg)
    submitAnomaly({
      errorType: 'error',
      errorDescription: serializeError(msg),
      browserDetails: getBrowserDetails()
    })
  },

  trace: msg => {
    logStub(msg);
  },

  debug: msg => {
    logStub(msg);
  }
}

function logStub(msg){
    console.log(msg);// eslint-disable-line
}

function getBrowserDetails() {
  let browser = {
    os : navigator.platform,
    cookiesEnabled: navigator.cookieEnabled,
    appName: navigator.appName,
    appCodeName: navigator.appCodeName,
    product: navigator.product,
    appVersion: navigator.appVersion,
    userAgent: navigator.userAgent,
    url: window.location.href,
    screen: {
      width: window.screen.width,
      height: window.screen.height
    }
  }

  return browser
}

function submitAnomaly(error) {
  //eslint-disable-next-line no-undef
  const baseApiUrl = process.env.BASE_API_URL || __baseApiUrl__

  api().post(`${baseApiUrl}/api/v1/utils/log`, error).
    then((res) => {
      logStub(error.errorDescription)
    }).
    catch((error) => {
      logStub(error)
    })
}


// WEBPACK FOOTER //
// ./src/common/logger/index.js